import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomerPanelComponent } from 'src/views/customer-panel/customer-panel.component';
import { MaterialModule } from './material.module';
import { CustomerRoutingModule } from 'src/routes/customer-routing.module';
import { LoadingComponent } from 'src/components/loading/loading.component';
import { ProfileComponent } from 'src/components/profile/profile.component';
import { ProfessionalExperiencesComponent } from 'src/components/professional-experiences/professional-experiences.component';
import { EmptyContentComponent } from 'src/components/empty-content/empty-content.component';
import { SchoolingComponent } from 'src/components/schooling/schooling.component';
import { NgxMaskModule } from 'ngx-mask';
import { UserProcessListComponent } from 'src/components/user-process-list/user-process-list.component';
import { UserProcessListDialogComponent } from 'src/components/user-process-list-dialog/user-process-list-dialog.component';
import { UserProcessListQuestionDialogComponent } from 'src/components/user-process-list-question-dialog/user-process-list-question-dialog.component'
import { CheckoutDialogComponent } from 'src/components/checkout-dialog/checkout-dialog.component';
import { MyAccountCompanyComponent } from 'src/components/my-account-company/my-account-company.component';
import { SignatureFailledDialogComponent } from 'src/components/signature-failled-dialog/signature-failled-dialog.component';
import { PlanSlideComponent } from 'src/components/plan-slide/plan-slide.component';
import { CandidateCommentDialogComponent } from 'src/components/candidate-comment-dialog/candidate-comment-dialog.component';
import { AskToShowInfoDialogComponent } from 'src/components/ask-to-show-info-dialog/ask-to-show-info-dialog.component';
// import { MatDialogModule } from '@angular/material/dialog';
import { WelcomeComponent } from 'src/components/welcome/welcome.component';
import { CurriculoComponent } from 'src/components/curriculo/curriculo.component';
import { CurriculoDialogComponent } from 'src/components/curriculo/curriculo-dialog/curriculo-dialog.component';
import { CurriculoAlertComponent } from 'src/components/curriculo/curriculo-alert/curriculo-alert.component';
import { ValidTermosComponent } from 'src/components/valid-termos/valid-termos.component';
import { environment } from 'src/environments/environment';
import { SharedProcessListComponent } from 'src/components/shared-process-list/shared-process-list.component';
import { CandidatesApprovalComponent } from 'src/components/candidates-approval/candidates-approval.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { SharedModule } from './shared.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { UserProcessListInterviewDialogComponent } from 'src/components/user-process-list-interview-dialog/user-process-list-interview-dialog.component';

export const customCurrencyMaskConfig = {
    align: 'left',
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "R$ ",
    suffix: "",
    thousands: ".",
    nullable: true,
    min: null,
    max: null,
    inputMode: CurrencyMaskInputMode.FINANCIAL
};

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        CustomerRoutingModule,
        NgxMaskModule.forChild(),
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
        SharedModule,
        FullCalendarModule,
    ],
    declarations: [
        CustomerPanelComponent,
        LoadingComponent,
        ProfileComponent,
        ProfessionalExperiencesComponent,
        EmptyContentComponent,
        SchoolingComponent,
        UserProcessListComponent,
        UserProcessListDialogComponent,
        UserProcessListQuestionDialogComponent,
        CheckoutDialogComponent,
        MyAccountCompanyComponent,
        SignatureFailledDialogComponent,
        PlanSlideComponent,
        CandidateCommentDialogComponent,
        AskToShowInfoDialogComponent,
        WelcomeComponent,
        CurriculoComponent,
        CurriculoDialogComponent,
        CurriculoAlertComponent,
        ValidTermosComponent,
        SharedProcessListComponent,
        CandidatesApprovalComponent,
        UserProcessListInterviewDialogComponent
    ],
    exports: [
        PlanSlideComponent
    ],
    providers: [
        {
            provide: 'LinkContrato',
            useValue: environment.LinkContrato
        },
        {
            provide: 'LinkTermos',
            useValue: environment.LinkTermos
        },
    ]
})
export class CustomerModule {



}